<template>
    <div class="mx_content">
        <div class="mx_title">
            <div class="title_left">
                <span>报销明细</span>
                <span style="margin-left: 10px">报销总额：￥{{ countAll }}</span>
            </div>
            <div class="title_right">
                <el-button v-if="canEdit" size="mini" @click="addMx">添加</el-button>
            </div>
        </div>
        <el-table v-if="updated" :data="listData" style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="index" label="序号" width="50" align="center" />
            <el-table-column prop="feeType" label="费用类型" align="center" width="200px">
                <template slot-scope="scope">
                    <div v-if="canEdit">
                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="费用类型" :rules="feeTypeRules">
                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                <el-input v-model="scope.row.feeType" v-can-edit :can-edit="canEdit" name="feeType" placeholder="请输入" />
                            </el-tooltip>
                        </ValidationProvider>
                    </div>
                    <div v-else>{{ scope.row.feeType }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="feeAmount" label="费用金额（元）" align="center" width="150px">
                <template slot-scope="scope">
                    <div v-if="canEdit">
                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="费用金额（元）" :rules="feeAmountRules">
                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                <el-input v-model="scope.row.feeAmount" v-can-edit :can-edit="canEdit" placeholder="请输入" name="feeAmount" @input="validateInput(scope.row.feeAmount, scope)" />
                            </el-tooltip>
                        </ValidationProvider>
                    </div>
                    <div v-else>{{ scope.row.feeAmount }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="occureDate" label="费用发生日期" align="center" width="200px">
                <template slot-scope="scope">
                    <div v-if="canEdit">
                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="费用发生日期" :rules="occureDateRules">
                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                <el-date-picker v-model="scope.row.occureDate" style="width: 100%" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" :type="dateType" placeholder="请选择" :editable="false" :clearable="true" />
                            </el-tooltip>
                        </ValidationProvider>
                    </div>
                    <div v-else>
                        <span v-if="scope.row.occureDate"> {{ $moment(scope.row.occureDate).format('YYYY年MM月DD日') }}</span>
                        <span v-else> - </span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="fileName" label="发票" align="center" width="150px">
                <template slot-scope="scope">
                    <div v-if="canEdit" @click="uploadChange(scope.row)">
                        <ValidationProvider ref="ValidationProvider" name="发票">
                            <div v-if="scope.row.passenger.attachments && scope.row.passenger.attachments.length > 0" class="attachment-link-wrapper">
                                <el-link :style="{ color: scope.row.invoiceStatus === 2 ? 'red' : '#409eff' }" :title="scope.row.passenger.attachments[0].fileName" class="attachment-link" @click="download(scope.row.passenger.attachments[0])">
                                    {{ truncateFileName(scope.row.passenger.attachments[0].fileName) }}
                                </el-link>
                                <span v-if="canEdit" class="remove-button" style="color: red; margin-left: 10px" @click="handleRemove(scope.row.passenger.attachments[0], scope.row)">x</span>
                            </div>
                            <el-upload v-else ref="uploadRef" class="upload-demo" action="#" :on-change="fileChange" :auto-upload="false" :on-remove="handleRemove" :multiple="false" :file-list="scope.row.passenger.attachments" :show-file-list="false">
                                <div style="color: #409eff">上传</div>
                            </el-upload>
                        </ValidationProvider>
                    </div>
                    <div v-else @click="uploadChange(scope.row)">
                        <div v-if="vo.wfNodeNames === '财务部负责人'" class="cwbfzr">
                            <span v-if="scope.row.invoiceStatus === 2" style="color: red" @click="openDialog(scope.row)">{{ scope.row.passenger.attachments[0].fileName }}</span>
                            <span v-else>
                                <el-link v-if="scope.row.passenger.attachments && scope.row.passenger.attachments.length > 0" :style="{ color: scope.row.invoiceStatus === 2 ? 'red' : '#409eff' }" :title="scope.row.passenger.attachments[0].fileName" class="attachment-link" @click="download(scope.row.passenger.attachments[0])">
                                    {{ truncateFileName(scope.row.passenger.attachments[0].fileName) }}
                                </el-link>
                            </span>
                        </div>
                        <div v-else>
                            <div class="attachment-link-wrapper">
                                <el-link v-if="scope.row.passenger.attachments && scope.row.passenger.attachments.length > 0" :style="{ color: scope.row.invoiceStatus === 2 ? 'red' : '#409eff' }" :title="scope.row.passenger.attachments[0].fileName" class="attachment-link" @click="download(scope.row.passenger.attachments[0])">
                                    {{ truncateFileName(scope.row.passenger.attachments[0].fileName) }}
                                </el-link>
                                <span v-if="canEdit" class="remove-button" style="color: red; margin-left: 10px" @click="handleRemove(scope.row.passenger.attachments[0], scope.row)">x</span>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="feeDesc" label="费用说明" align="center">
                <template slot-scope="scope">
                    <div v-if="canEdit">
                        <el-input v-model="scope.row.feeDesc" v-can-edit :can-edit="canEdit" name="feeDesc" placeholder="请输入" />
                    </div>
                    <div v-else>{{ scope.row.feeDesc }}</div>
                </template>
            </el-table-column>

            <el-table-column v-if="canEdit" label="操作" align="center" width="70px">
                <template slot-scope="scope">
                    <el-link type="primary" @click="delClick(scope.row)">删除</el-link>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog title="异常明细" :visible.sync="dialogVisible" width="50%" :before-close="handleClose" class="dialogStyle">
            <el-table :data="ycmxData" style="width: 100%">
                <el-table-column type="index" label="序号" width="50" align="center" />
                <el-table-column label="申请单" align="center">
                    <template slot-scope="scope">
                        <div style="float: left">{{ scope.row.passenger.flSubject }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="发票" align="center" width="150px">
                    <template slot-scope="scope">
                        <div>{{ scope.row.fileName }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="上传人" align="center" width="100px">
                    <template slot-scope="scope">
                        <div>{{ scope.row.uploadBy }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="上传时间" align="center" width="160px">
                    <template slot-scope="scope">
                        <div>{{ scope.row.uploadTime }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="状态" align="center" width="160px">
                    <template slot-scope="scope">
                        <el-select v-if="scope.row.passenger.invoiceStatus === 2" v-model="scope.row.passenger.invoiceStatus" placeholder="请选择" @change="changeFn(scope.row, scope.$index)">
                            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                        <div v-else>{{ statusFormat(scope.row.passenger.invoiceStatus) }}</div>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="sureBtn">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
const { uuid } = require('@/global/utils/index.js')
import moment from 'moment'
export default {
    components: {},
    props: {
        // 通用属性
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 },
        module: { type: String, default: null },
        baseUrl: { type: String, default: null },
        listName: { type: String, default: null },
        isHttp: { type: Boolean, default: true }

        // 自定义属性
    },
    setup() {
        const feeTypeRules = {
            required: true
        }
        const feeDescRules = {
            required: true
        }
        const occureDateRules = {
            required: true
        }

        const feeAmountRules = {
            required: true
        }

        const handleFeeAmountInput = (value) => {
            // 这里可以添加对费用金额的其他校验逻辑
        }

        // 如果需要，可以在这里添加对ValidationProvider实例的引用逻辑
        // 例如：
        // const { validate } = useValidation();
        // ...

        return {
            feeTypeRules,
            feeAmountRules,
            handleFeeAmountInput,
            feeDescRules,
            occureDateRules
            // ... 其他响应式引用
        }
    },
    data() {
        return {
            // 通用变量
            moduleInfo: {},
            loginUser: this.$store.getters.loginUser,
            listData: [],
            // 自定义变量
            countAll: '0.00',
            updated: true,
            uploadId: '', // 当前上传行id
            dialogVisible: false,
            options: [
                {
                    value: 1,
                    label: '正常'
                },
                {
                    value: 2,
                    label: '异常'
                }
            ],
            rowStatus: '',
            rowItemId: ''
        }
    },
    computed: {},
    watch: {
        listData: {
            handler(newVal, oldVal) {
                // 当listData发生变化时，更新vo.passenger[listName]
                this.vo.passenger[this.listName] = newVal
            },
            deep: true
        }
    },
    created() {},
    beforeDestroy() {},
    mounted() {
        this.moduleInfo = {
            delUrl: '/' + this.baseUrl + '/' + this.module + '/delete',
            addNewUrl: '/' + this.baseUrl + '/' + this.module + '/addNew',
            insertUrl: '/' + this.baseUrl + '/' + this.module + '/insert',
            moduleCode: this.module,
            updateUrl: '/' + this.baseUrl + '/' + this.module + '/update',
            listDataUrl: '/' + this.baseUrl + '/' + this.module + '/listdata',
            getByIdUrl: '/' + this.baseUrl + '/' + this.module + '/getById',
            querydata: '/' + this.baseUrl + '/' + this.module + '/querydata'
        }
        this.getListData()
    },
    updated() {},
    methods: {
        statusFormat(val) {
            var str = ''
            switch (val) {
                case 1:
                    str = '正常'
                    break
                case 2:
                    str = '异常'
                    break
            }
            return str
        },
        uploadChange(row) {
            this.uploadId = row.id
        },
        truncateFileName(fileName) {
            // 这里只是一个简单的示例，你可以根据需要调整逻辑
            const maxLength = 20 // 你可以设置你想要的最大长度
            if (fileName.length > maxLength) {
                return fileName.substring(0, maxLength) + '...'
            }
            return fileName
        },
        fileChange(files, fileList) {
            if (fileList.length > 0) {
                this.uploadAttach([files])
            }
        },
        uploadAttach(fileList) {
            const uploadId = this.uploadId
            fileList.forEach((item) => {
                const fd = new FormData()
                fd.append('file', item.raw)
                fd.append('module', this.module)
                fd.append('busiDataId', uploadId)
                fd.append('attachsType', 'ATTACH')
                fd.append('clientType', 'uploader')
                fd.append('attachsName', item.name)

                // this.updated = false
                // this.listData.forEach(i => {
                //     if (i.id === this.uploadId) {
                //         // 如果attachments数组还不存在，则创建它
                //         if (!i.passenger.attachments) {
                //             this.$set(i.passenger, 'attachments', [{}])
                //         }

                //         // 设置或更新attachments数组的第一个元素
                //         this.$set(i.passenger.attachments[0], 'fileName', item.name)
                //     }
                // })
                // this.updated = true // 标记已更新
                this.$http({
                    method: 'post',
                    url: '/' + this.baseUrl + '/' + this.module + '/autoRecognitionInvoice',
                    data: fd
                }).then((res) => {
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                        this.listData.forEach((i) => {
                            if (i.id === uploadId) {
                                // 如果attachments数组还不存在，则创建它
                                if (!i.passenger.attachments) {
                                    this.$set(i.passenger, 'attachments', [{}])
                                }
                                i.invoiceStatus = res.body.invoiceStatus
                                i.passenger.attachments = [...res.body.uploadAttachList]
                            }
                        })
                    } else {
                        this.$message.error(res.message)
                    }
                })
            })
        },
        handleRemove(file, row) {
            this.$http({
                method: 'delete',
                url: '/' + this.baseUrl + '/' + this.module + '/deleteAttach',
                params: {
                    attachIds: file.id
                }
            }).then((res) => {
                if (res.code === 'success') {
                    this.updated = false
                    this.$message.success(res.message)
                    this.listData.forEach((i) => {
                        if (i.id === row.id) {
                            i.passenger.attachments = []
                        }
                    })
                    this.$nextTick(() => {
                        this.updated = true
                    })
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        download(attach) {
            if (attach.id === undefined) return
            window.open(process.env.VUE_APP_BASE_API + '/' + this.baseUrl + '/' + this.module + '/downloadById?inline=true&attachIds=' + attach.id)
        },
        getCountAll() {
            let count = 0
            this.listData.forEach((item) => {
                if (item.feeAmount) {
                    count += Number(item.feeAmount)
                }
            })

            this.countAll = count
            this.vo.expenseAmount = this.countAll
            this.vo.payAmount = this.countAll
        },
        async getListData(model) {
            if (this.isHttp) {
                const data = [{ compare: '=', field: 'formId', merge: false, value: this.vo.id }]
                const res = await this.$app.querydata(this.moduleInfo.querydata, data)
                if (res.code === 'success') {
                    this.listData = res.body.listdata
                }
            } else if (this.listName) {
                if (this.vo.passenger && this.vo.passenger[this.listName] && this.vo.passenger[this.listName].length > 0) {
                    this.vo.passenger[this.listName].forEach((item) => {
                        if (!item.formId) {
                            item.formId = this.vo.id
                        }
                        if (!item.id) {
                            item.id = uuid()
                        }
                        if (!item.occureDate && item.occurDate) {
                            item.occureDate = item.occurDate
                        }
                        if (!item.creatorId) {
                            item.creatorId = this.loginUser.id
                        }
                        if (item.invoiceStatus === null) {
                            item.invoiceStatus = 0
                        }
                        if (!item.createTime) {
                            // 获取当前时间
                            const now = moment()
                            // 格式化当前时间
                            const formattedNow = now.format('YYYY-MM-DD HH:mm:ss')
                            item.createTime = formattedNow
                        }
                    })
                    this.listData = this.vo.passenger[this.listName]
                    this.getCountAll()
                }
            } else {
                console.log('请传递listName参数或改用接口获取数据')
            }
        },
        // 监听input，处理数字
        validateInput(value, scope) {
            value = value.replace(/[^\d.]/g, '') // 只保留数字和小数点
            value = value.replace(/^\./, '') // 去掉开头的小数点
            value = value.replace(/\.{2,}/g, '.') // 去掉多余的小数点
            value = value.replace(/^0+(\d)/, '$1') // 去掉开头的多余零
            value = value.replace(/^(\d+\.\d\d)\d+$/, '$1') // 限制只能输入两位小数
            this.$set(this.listData[scope.$index], scope.column.property, value)
            this.getCountAll()
        },
        // 删除当前行
        delClick(row) {
            // 找到要删除的项的索引
            const index = this.listData.findIndex((item) => item.id === row.id)
            if (index !== -1) {
                // 使用splice方法删除该项
                this.listData.splice(index, 1)
                this.getCountAll()
            } else {
                console.error('未找到要删除的数据项')
            }
        },
        addMx() {
            this.$http({
                url: this.moduleInfo.addNewUrl,
                method: 'post'
            }).then((res) => {
                if (res.code === 'success') {
                    res.body.vo.formId = this.vo.id
                    res.body.vo.creatorId = this.loginUser.id
                    if (res.body.vo.invoiceStatus === null) {
                        res.body.vo.invoiceStatus = 0
                    }
                    // 获取当前时间
                    const now = moment()
                    // 格式化当前时间
                    const formattedNow = now.format('YYYY-MM-DD HH:mm:ss')
                    res.body.vo.createTime = formattedNow
                    this.listData.push(res.body.vo)
                }
            })
        },
        openDialog(row) {
            this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                params: { itemId: row.id },
                url: 'cwgl/fybxItem/getVoiceAttach'
            }).then(
                (response) => {
                    if (response.code === 'success') {
                        this.ycmxData = response.body.attachments
                        this.dialogVisible = true
                    } else {
                        this.$message.error(response.message)
                    }
                },
                (err) => {
                    console.log(err)
                }
            )
        },
        changeFn(row) {
            this.rowItemId = row.passenger.itemId
            this.rowStatus = row.passenger.invoiceStatus
        },
        sureBtn() {
            if (!this.rowStatus && !this.rowItemId) {
                this.dialogVisible = false
                return
            }
            this.$http({
                contentType: 'application/x-www-form-urlencoded',
                url: 'cwgl/fybxItem/updateBatchByIdAndInvoiceStatus',
                method: 'POST',
                data: [
                    {
                        invoiceStatus: this.rowStatus,
                        id: this.rowItemId
                    }
                ]
            }).then((res) => {
                if (res.code === 'success') {
                    this.$message.success(res.message)
                    this.dialogVisible = false
                    this.vo.passenger[this.listName].forEach((item) => {
                        if (item.id === this.rowItemId) {
                            item.invoiceStatus = this.rowStatus
                        }
                    })
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
/deep/ .el-table .el-link--inner {
    width: 100%;
}
.mx_content /deep/ .el-table__body-wrapper tr td:last-child {
    border-right-color: #e2e7ed !important;
}
.mx_content {
    .mx_title {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #999;
        justify-content: space-between;
        // background: #f2f5fb;
        padding: 0 10px;
    }
}

.attachment-link-wrapper {
    display: flex;
    align-items: center;
    /* 如果需要垂直居中 */
    justify-content: space-between;
    /* 确保链接和按钮之间有间隔，并分别位于开始和结束位置 */
    .el-lint-inner {
        width: 100%;
    }
}

.attachment-link {
    flex: 1;
    /* 占据可用空间，但不会挤压删除按钮 */
    overflow: hidden;
    /* 隐藏超出容器的部分 */
    text-overflow: ellipsis;
    /* 显示省略号 */
    white-space: nowrap;
    /* 防止文本换行 */
    /* 其他你需要的样式 */
}

.remove-button {
    /* 确保按钮始终可见，并位于行尾 */
    /* 你可以添加更多的样式来美化按钮 */
}
/deep/.el-dialog__header {
    height: 54px;
}
/deep/.el-dialog__wrapper .el-dialog__title::before {
    top: 15.5px;
}
/deep/.el-textarea__inner {
    min-height: 70px !important;
    height: 70px !important;
}
.dialogStyle {
    /deep/.el-table {
        border: 1px solid #999;
        border-bottom: #fff;
    }
}
</style>
